/**
 * Auto-generated file created by svgr-cli source svgr.template.config.js
 * Run yarn svgr to update
 * Do not edit
 */
import * as React from 'react'
import { SVGProps, memo } from 'react'
const SvgMenuSync = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 24}
    height={props.height || 24}
    fill="currentColor"
    viewBox="0 0 16 16"
    color={props.color || '#EE4D2D'}
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.6 4.216H4.038c-.915 0-1.656.728-1.656 1.627v2.499H1V5.836c0-1.653 1.36-2.988 3.035-2.988H11.6V1l3.286 2.531L11.6 6.062V4.216Zm3.4 5.949c0 1.652-1.359 2.988-3.034 2.988H4.405V15L1.12 12.472l3.284-2.528v1.847h7.557c.915 0 1.656-.727 1.656-1.626V7.666H15v2.5Z"
    />
  </svg>
)
const Memo = memo(SvgMenuSync)
export default Memo
